const UPGRADE_MAPPING={"43496051114083":"43495965163619","43496051081315":"43495954186339","40770912157795":"43455570903139","40770911764579":"40982046343267","43455549767779":"43455535874147","40770911895651":"40982046474339","43496051146851":"43495984791651","39875955163235":"40982046212195","43496051048547":"43495928758371","40784974577763":"40982041002083","43496050983011":"43495965130851","43496050950243":"43495954153571","40770912125027":"43455570870371","40770911731811":"40982046310499","43455549735011":"43455535841379","40770911862883":"40982046441571","43496051015779":"43495984758883","39875954770019":"40982046179427","43496050917475":"43495928725603","40784974544995":"40982040969315","43496050851939":"43495965098083","43496050819171":"43495954120803","40770912092259":"43455570837603","40770911699043":"40982046277731","43455549702243":"43455535808611","40770911830115":"40982046408803","43496050884707":"43495984726115","40152131371107":"40982046146659","43496050786403":"43495928692835","40784974512227":"40982040936547","43496051245155":"43495965196387","43496051212387":"43495954219107","40770912190563":"43455570935907","40770911797347":"40982046376035","43455549800547":"43455535906915","40770911928419":"40982046507107","43496051277923":"43495984824419","39875955589219":"40982046244963","43496051179619":"43495928791139","40784974610531":"40982041034851","43496051638371":"43495965294691","43496051605603":"43495954317411","40770912682083":"43455571034211","40770912288867":"40982046998627","43455549898851":"43455536005219","40770912419939":"40982047129699","43496051671139":"43495984922723","39875955130467":"40982046867555","43496051572835":"43495928889443","40784974708835":"40982046736483","43496051507299":"43495965261923","43496051474531":"43495954284643","40770912649315":"43455571001443","40770912256099":"40982046965859","43455549866083":"43455535972451","40770912387171":"40982047096931","43496051540067":"43495984889955","39875954737251":"40982046834787","43496051441763":"43495928856675","40784974676067":"40982046703715","43496051376227":"43495965229155","43496051343459":"43495954251875","40770912616547":"43455570968675","40770912223331":"40982046933091","43455549833315":"43455535939683","40770912354403":"40982047064163","43496051408995":"43495984857187","40152131502179":"40982046802019","43496051310691":"43495928823907","40784974643299":"40982046670947","43496051769443":"43495965327459","43496051736675":"43495954350179","40770912714851":"43455571066979","40770912321635":"40982047031395","43455549931619":"43455536037987","40770912452707":"40982047162467","43496051802211":"43495984955491","39875955556451":"40982046900323","43496051703907":"43495928922211","40784974741603":"40982046769251","43496052162659":"43495965032547","43496052129891":"43495954055267","40770913206371":"43455570772067","40770912813155":"42083028893795","43455550029923":"43455535743075","40770912944227":"42083028762723","43496052195427":"43495984660579","39875955196003":"42083028631651","43496052097123":"43495928627299","40784974839907":"42083028500579","43496052031587":"43495964999779","43496051998819":"43495954022499","40770913173603":"43455570739299","40770912780387":"42083028861027","43455549997155":"43455535710307","40770912911459":"42083028729955","43496052064355":"43495984627811","39875954802787":"42083028598883","43496051966051":"43495928594531","40784974807139":"42083028467811","43496051900515":"43495964967011","43496051867747":"43495953989731","40770913140835":"43455570706531","40770912747619":"42083028828259","43455549964387":"43455535677539","40770912878691":"42083028697187","43496051933283":"43495984595043","40152131633251":"42083028566115","43496051834979":"43495928561763","40784974774371":"42083028435043","43496052293731":"43495965065315","43496052260963":"43495954088035","40770913239139":"43455570804835","40770912845923":"42083028926563","43455550062691":"43455535775843","40770912976995":"42083028795491","43496052326499":"43495984693347","39875955621987":"42083028664419","43496052228195":"43495928660067","40784974872675":"42083028533347","43496052686947":"43495965425763","43496052654179":"43495954448483","40770913730659":"43455571165283","40770913337443":"41978016530531","43455550160995":"43455536136291","40770913468515":"41978016399459","43496052719715":"43495985053795","39966760599651":"41978016268387","43496052621411":"43495929020515","40784974970979":"41978016137315","43496052555875":"43495965392995","43496052523107":"43495954415715","40770913697891":"43455571132515","40770913304675":"41978016497763","43455550128227":"43455536103523","40770913435747":"41978016366691","43496052588643":"43495985021027","39966751228003":"41978016235619","43496052490339":"43495928987747","40784974938211":"41978016104547","43496052424803":"43495965360227","43496052392035":"43495954382947","40770913665123":"43455571099747","40770913271907":"41978016464995","43455550095459":"43455536070755","40770913402979":"41978016333923","43496052457571":"43495984988259","40152131764323":"41978016202851","43496052359267":"43495928954979","40784974905443":"41978016039011","43496052818019":"43495965458531","43496052785251":"43495954481251","40770913763427":"43455571198051","40770913370211":"41978016563299","43455550193763":"43455536169059","40770913501283":"41978016432227","43496052850787":"43495985086563","39966767612003":"41978016301155","43496052752483":"43495929053283","40784975003747":"41978016170083","43496053211235":"43495965556835","43496053178467":"43495954579555","40770914254947":"43455571296355","40770913861731":"42553302712419","43455550292067":"43455536267363","40770913992803":"42553302581347","43496053244003":"43495985184867","40757951627363":"42553302450275","43496053145699":"43495929151587","40784975102051":"42553302319203","43496053080163":"43495965524067","43496053047395":"43495954546787","40770914222179":"43455571263587","40770913828963":"42553302679651","43455550259299":"43455536234595","40770913960035":"42553302548579","43496053112931":"43495985152099","40757951594595":"42553302417507","43496053014627":"43495929118819","40784975069283":"42553302286435","43496052949091":"43495965491299","43496052916323":"43495954514019","40770914189411":"43455571230819","40770913796195":"42553302646883","43455550226531":"43455536201827","40770913927267":"42553302515811","43496052981859":"43495985119331","40757951561827":"42553302384739","43496052883555":"43495929086051","40784975036515":"42553302253667","43496053342307":"43495965589603","43496053309539":"43495954612323","40770914287715":"43455571329123","40770913894499":"42553302745187","43455550324835":"43455536300131","40770914025571":"42553302614115","43496053375075":"43495985217635","40757951660131":"42553302483043","43496053276771":"43495929184355","40784975134819":"42553302351971"};async function upgradeCartItem(oldVariantId,quantity=1){const upgradeButton=event.target,originalText=upgradeButton.innerHTML,newVariantId=UPGRADE_MAPPING[oldVariantId];if(!newVariantId){console.error("No upgrade mapping found for variant:",oldVariantId),showNotification("\u274C Unable to upgrade. Please try again.","error");return}upgradeButton.disabled=!0,upgradeButton.innerHTML="\u23F3 Upgrading...",upgradeButton.style.opacity="0.6";try{if(await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:oldVariantId,quantity:0})}),!(await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:newVariantId,quantity}]})})).ok)throw new Error("Failed to add upgraded item");await refreshCart(),showNotification("\u2705 Upgraded! You're getting the premium harness.","success")}catch(error){console.error("Upgrade failed:",error),showNotification("\u274C Unable to upgrade. Please try again.","error"),upgradeButton.disabled=!1,upgradeButton.innerHTML=originalText,upgradeButton.style.opacity="1"}}async function refreshCart(){try{const cart=await(await fetch("/cart.js")).json();document.dispatchEvent(new CustomEvent("cart:refresh",{detail:cart})),document.dispatchEvent(new CustomEvent("cart:updated",{detail:cart}))}catch(error){console.warn("AJAX cart refresh failed:",error)}setTimeout(()=>{window.location.reload()},500)}function showNotification(message,type="success"){const existing=document.querySelector(".tk9-upgrade-notification");existing&&existing.remove();const notification=document.createElement("div");notification.className=`tk9-upgrade-notification tk9-notification-${type}`,notification.textContent=message;const bgColor=type==="success"?"#4CAF50":"#f44336";notification.style.cssText=`
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${bgColor};
    color: white;
    padding: 15px 25px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 99999;
    font-size: 16px;
    font-weight: 600;
    animation: slideIn 0.3s ease;
  `,document.body.appendChild(notification),setTimeout(()=>{notification.style.animation="slideOut 0.3s ease",setTimeout(()=>notification.remove(),300)},3e3)}const style=document.createElement("style");style.textContent=`
  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }

  .tk9-upgrade-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 8px;
    display: inline-block;
  }

  .tk9-upgrade-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }

  .tk9-upgrade-btn:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .tk9-upgrade-badge {
    background: #FF6B6B;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    margin-left: 8px;
  }
`,document.head.appendChild(style);function hasUpgrade(variantId){return UPGRADE_MAPPING.hasOwnProperty(variantId.toString())}window.TeamK9Upgrade={upgradeCartItem,hasUpgrade,UPGRADE_MAPPING};
//# sourceMappingURL=/cdn/shop/t/46/assets/cart-upgrade.js.map?v=146126595436208300121761330973
(function(){if(!/\/pages\/backseat-dog-cooling-fans-feature(?:$|[/?#])/.test(window.location.pathname))return;if(window.__tk9FanAtcLiveRequested)return;window.__tk9FanAtcLiveRequested=true;var script=document.createElement("script");script.src="https://cdn.shopify.com/s/files/1/2715/4364/t/64/assets/tk9-fan-atc-live.js?v=1781192110";script.defer=true;document.head.appendChild(script);})();
(function () {
  // Retired in the Swatch King/BF Size Charts cutover. Team K9's native size
  // guide now renders beside the real Shopify option, so this legacy full-page
  // observer and 60-second polling path must never start.
  return;

  var isProductPage =
    window.location.pathname.indexOf("/products/") === 0 ||
    Boolean(document.querySelector('[data-template="product"], main[data-template="product"]'));

  if (!isProductPage || window.__tk9SizeGuideAnchor) return;
  window.__tk9SizeGuideAnchor = true;

  var hiddenClass = "tk9-size-guide-hidden";
  var scheduled = false;

  function ensureStyles() {
    if (document.getElementById("tk9-size-guide-anchor-style")) return;
    var style = document.createElement("style");
    style.id = "tk9-size-guide-anchor-style";
    style.textContent = "." + hiddenClass + "{display:none!important}";
    document.head.appendChild(style);
  }

  function hasSizeGuideText(node) {
    return /size\s*guide/i.test((node && node.textContent) || "");
  }

  function findSizeOption() {
    var options = document.querySelectorAll("variant-swatch-king [option-name], .swatches [option-name]");

    for (var index = 0; index < options.length; index += 1) {
      var option = options[index];
      var name = option.getAttribute("option-name") || "";
      if (/size/i.test(name)) return option;
    }

    var fallback = document.querySelector("#swatch-option2");
    if (fallback && /size/i.test(fallback.textContent || "")) return fallback;

    return null;
  }

  function ensureSlot(sizeOption) {
    var labelContainer =
      sizeOption.querySelector(".swatch-label-container") || sizeOption.querySelector("fieldset") || sizeOption;
    var slot = labelContainer.querySelector(".swatch-size-chart");

    if (!slot) {
      slot = document.createElement("span");
      slot.className = "swatch-size-chart";
      labelContainer.appendChild(slot);
    }

    return slot;
  }

  function getCharts() {
    var seen = [];
    var charts = [];

    function add(node) {
      if (!node || seen.indexOf(node) !== -1 || !hasSizeGuideText(node)) return;
      if (node.closest("template")) return;
      seen.push(node);
      charts.push(node);
    }

    document.querySelectorAll(".best-fit-size-chart").forEach(add);
    document.querySelectorAll(".scr-open-size-chart").forEach(function (button) {
      add(button.closest(".best-fit-size-chart") || button.parentElement || button);
    });

    return charts;
  }

  function anchorSizeGuide() {
    var sizeOption = findSizeOption();
    var charts = getCharts();

    if (!sizeOption || !charts.length) return false;

    var slot = ensureSlot(sizeOption);
    var primary =
      charts.find(function (chart) {
        return slot.contains(chart);
      }) ||
      charts.find(function (chart) {
        return sizeOption.contains(chart);
      }) ||
      charts[0];

    if (!primary) return false;

    ensureStyles();

    if (!slot.contains(primary)) {
      slot.appendChild(primary);
    }

    primary.classList.remove(hiddenClass);
    primary.removeAttribute("aria-hidden");
    primary.setAttribute("data-tk9-size-guide-anchor", "size-row");

    charts.forEach(function (chart) {
      if (chart === primary) return;
      chart.classList.add(hiddenClass);
      chart.setAttribute("aria-hidden", "true");
    });

    return true;
  }

  function scheduleAnchor() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      anchorSizeGuide();
    });
  }

  anchorSizeGuide();
  document.addEventListener("DOMContentLoaded", scheduleAnchor);
  window.addEventListener("load", scheduleAnchor);
  document.addEventListener("shopify:section:load", scheduleAnchor);

  if (window.MutationObserver) {
    // tk9-fix 2026-06-19: bounded — was a PERPETUAL full-page observer (observer-storm
    // contributor that helped freeze the page). The retry interval below already covers late
    // mounts; disconnect the observer after the page settles.
    var sizeGuideObserver = new MutationObserver(scheduleAnchor);
    sizeGuideObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { sizeGuideObserver.disconnect(); }, 10000);
  }

  var attempts = 0;
  var retry = window.setInterval(function () {
    attempts += 1;
    anchorSizeGuide();
    if (attempts >= 60) window.clearInterval(retry);
  }, 1000);
})();
